//? PLUGINS //
import { Box, Card, useMediaQuery, useTheme } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import * as Yup from "yup";

//? COMPONENTS //
import Content from "pages/requests/stepsIndividual/step3/step3.content";

//? STYLES //
import * as Styles from "pages/requests/stepsIndividual/step2/step2.styles";

//! ------------------------------------------------------------------------------------ //

export const INITIAL_FORM_STATE_STEP3: { dateFrom: string, dateTo: string, zone: string, locations: string[], reason: string, function: string } = {
    dateFrom: "",
    dateTo: "",
    zone: "",
    locations: [],
    reason: "",
    function: "",
};

export const FORM_VALIDATION_STEP3 = (t: any, titlePath: string) => {
    return Yup.object().shape({
        dateFrom: Yup.date()
            .typeError("Not A Date error")
            .required("yup.required")
            .test(
                "is-today",
                "yup.step3.dateFrom",
                (date) => {
                    if (titlePath === "requestAll.completeTitle") return true;
                    return dayjs().diff(date, "days") <= 0
                }
            )
            .test(
                "is-max-3m-in-future",
                "yup.step3.dateFrom3Months",
                (date) => dayjs().add(3, "months").diff(date, "days") >= 0
            ),
        dateTo: Yup.date()
            .typeError("yup.step3.dateError")
            .when("dateFrom", (dateFrom: Date, schema: Yup.DateSchema) => {
                const day = dayjs(dateFrom).add(1, "years").add(1, "day");
                if (dateFrom == null)
                    return schema.max(dayjs(), "yup.step3.dateFromIsEmpty");
                return schema.max(
                    day,
                    `${"yup.step3.maxDate"} (${day
                        .subtract(1, "day")
                        .format("DD/MM/YYYY")})`
                );
            })
            .min(Yup.ref("dateFrom"), "yup.step3.minDate")
            .required("yup.required"),
        zone: Yup.string().required("yup.required"),
        locations: Yup.array().min(1, "yup.step3.locations").required(),
        reason: Yup.string().required("yup.required").nullable(),
        function: Yup.string().required("yup.required").nullable(),
    });
};

interface Props {
    title: string;
    onBackClick: () => void;
    titlePath?: string;
}

const Step3 = ({ title, onBackClick, titlePath }: Props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.between("xs", "lg"));

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                mt: "50px",
            }}
        >
            {isMobile ? (
                <Content title={title} onBackClick={onBackClick} titlePath={titlePath} />
            ) : (
                <Card sx={Styles.cardCSS(theme)}>
                    <Content title={title} onBackClick={onBackClick} titlePath={titlePath} />
                </Card>
            )}
        </Box>
    );
};

export default Step3;
